import { render } from "./page-notifications.vue?vue&type=template&id=87ae4092"
import script from "./page-notifications.vue?vue&type=script&lang=js"
export * from "./page-notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__